/**
 * Safely invoke a given function with the given parameters by first checking if
 * `callback` is actually a function before invoking it.
 * @param {any} callback
 * @param {...any} parameters
 */
export default function safeInvoke(callback) {
  if (typeof callback === 'function') {
    for (var _len = arguments.length, parameters = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      parameters[_key - 1] = arguments[_key];
    }

    return callback.apply(void 0, parameters);
  }

  return undefined;
}